import AutoSubmitController from "./auto_submit_controller"
import CartAddController    from "./cart_add_controller"
import CartRemoveController from "./cart_remove_controller"
import ItemController       from "./item_controller"
import OverviewController   from "./overview_controller"
import ShippingController   from "./shipping_controller"

export default [
  { identifier: "auto-submit",  controllerConstructor: AutoSubmitController },
  { identifier: "cart-add",     controllerConstructor: CartAddController },
  { identifier: "cart-remove",  controllerConstructor: CartRemoveController },
  { identifier: "item",         controllerConstructor: ItemController },
  { identifier: "overview",     controllerConstructor: OverviewController },
  { identifier: "shipping",     controllerConstructor: ShippingController },
]
